const PHONE_DIGITS_COUNT = 10;

/**
 * Не пускает в поле телефона символ, который маска всё равно откатит: лишнюю цифру после полного номера или не цифру.
 * Маска убирает такой символ уже после вставки, а браузер успевает запомнить промежуточный текст
 * (например "+7 234 163 47656") и потом предлагает его в автозаполнении.
 * Вставка и автозаполнение идут не через keydown, их это не затрагивает.
 * allowNonDigits - для поля "телефон или email": там с буквы начинается ввод почты.
 */
export const preventRejectedPhoneKey = (event, { allowNonDigits = false } = {}) => {
    const { key, ctrlKey, metaKey, altKey, target } = event;

    //управляющие клавиши (Backspace, стрелки, Tab) и сочетания вроде Ctrl+V пропускаем
    if (key.length !== 1 || ctrlKey || metaKey || altKey) {
        return;
    }

    if (!/\d/.test(key)) {
        if (!allowNonDigits) {
            event.preventDefault();
        }
        return;
    }

    //выделенный текст цифра заменит, длина номера не вырастет
    if (target.selectionStart !== target.selectionEnd) {
        return;
    }

    const digitsAfterCountryCode = target.value.replace(/\D/g, '').length - 1;
    if (digitsAfterCountryCode >= PHONE_DIGITS_COUNT) {
        event.preventDefault();
    }
};
